// ** React Imports
import { Component } from "react"
import { Link } from 'react-router-dom'

// ** Reactstrap Imports
import { Button } from 'reactstrap'

// ** Third Party Components
import i18next from 'i18next'

// ** Styles
import '@styles/base/pages/page-misc.scss'

class ErrorBoundary extends Component {
   constructor(props) {
      super(props)
      this.state = { hasError: false }
   }

   static getDerivedStateFromError() {
      return { hasError: true }
   }

   componentDidCatch(error, errorInfo) {
      console.error("Error caught by ErrorBoundary:", error, errorInfo)
   }

   render() {

      if (this.state.hasError) {      
         const logo = require(`@src/assets/images/logo/logo-lg.svg`).default
      
         return (
            <div className='misc-wrapper'>
               <a className='brand-logo' href='/'>
                  <img src={logo} alt='' width='180px' />
               </a>
               <div className='misc-inner p-2 p-sm-3'>
                  <div className='w-100 text-center'>
                     <h2 className='mb-1'>{i18next.t('critical.Critical error on page', {ns: "pages"})}</h2>
                     <p className='mb-2'>{i18next.t('critical.Looks like you have critical error on page, plese try to press CTRL+R (or Command+R for Mac), to reload your page.', {ns: "pages"})}</p>
                     <Button tag={Link} to='/' color='primary' className='btn-sm-block mb-2'>
                        {i18next.t('critical.Back to main', {ns: "pages"})}
                     </Button>                     
                  </div>
               </div>
            </div>
         )         
      }

      return this.props.children
   }
}

export default ErrorBoundary